import React, { FC, memo, useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Modal } from '../../../../../components/Dashboard/Modal'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    boxSizing: 'border-box',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    width: 738,
  },
}))

interface IEditUserProfile {
  isOpen: boolean
  modalClose: (isShowUserProfileScreen?: boolean) => void
}

const EditUserProfileWarningPopup: FC<IEditUserProfile> = ({ isOpen, modalClose }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const classes = useStyles()
  const { handleSubmit } = formMethods

  const onSubmit = useCallback(
    // eslint-disable-next-line
    (data: any) => {
      modalClose(true)
      formMethods.reset()
    },
    // eslint-disable-next-line
    [],
  )

  return (
    <Modal
      title="Attention!"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      submitTitle={'Continue'}
      isWidthAuto={true}
    >
      <FormProvider {...formMethods}>
        <Grid container className={classes.container}>
          <Grid item xs={12}>
            <Typography>After changing the personal data you will have to pass KYC</Typography>
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}

export const MemoEditUserProfileWarningPopup = memo(EditUserProfileWarningPopup)
